export default "__VITE_ASSET__7e4d693a__"